<template>
  <div class="min-h-screen bg-primary">
    <SmartLeadCtaSection />
  </div>
</template>

<script setup lang="ts">
import SmartLeadCtaSection from "@/components/sections/cta/SmartLeadCtaSection.vue";
</script>
